import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
import { adjustSize } from "../functions/adjustable";
import { ADJUSTABLE_CONNECTOR } from "../constants";
export default class AdaptAdjustableSystem extends SystemBase {
    constructor() {
        super(COMPONENT_IDS.REQUIRE_SIZE_ADJUSTMENT_COMPONENT);
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = "AdaptAdjustableSystem";
    }
    onAddComponent(_entity, _newComponent) {
        super.onAddComponent(_entity, _newComponent);
        const { host, hostConnector } = _newComponent;
        adjustSize(_entity, ADJUSTABLE_CONNECTOR, host, hostConnector);
        _entity.removeComponent(COMPONENT_IDS.REQUIRE_SIZE_ADJUSTMENT_COMPONENT);
    }
}
